var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_URL, API_URL_OFFICE, API_URL_SHOP } from "./config";
export function getBackendDataPromise(username, endpoint, method, acceptFormat, token) {
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open(method, API_URL + endpoint + username);
        request.setRequestHeader('Accept', acceptFormat);
        request.setRequestHeader('Authorization', 'Bearer ' + token);
        request.addEventListener('load', function () {
            if (request.status >= 200 && request.status < 300) {
                resolve(request.responseText);
            }
            else {
                reject({
                    status: request.status,
                    statusText: request.statusText
                });
            }
        });
        request.addEventListener('error', () => {
            reject({
                status: request.status,
                statusText: request.statusText
            });
        });
        request.send();
    });
}
export function getBackendData(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.addEventListener('load', callback);
    request.send();
}
export function getBackendFile(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.responseType = 'blob';
    request.addEventListener('load', callback);
    request.send();
}
export function getShopBackendData(username, endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_SHOP + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.addEventListener('load', callback);
    request.send();
}
export function getOfficeBackendData(endpoint, method, acceptFormat, token, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_OFFICE + endpoint);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.addEventListener('load', callback);
    request.send();
}
export function sendShopBackendData(username, endpoint, method, acceptFormat, token, body, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_SHOP + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.setRequestHeader('Content-type', 'application/json');
    request.addEventListener('load', callback);
    request.send(JSON.stringify(body));
}
export function sendOfficeBackendData(endpoint, method, acceptFormat, token, body, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL_OFFICE + endpoint);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.setRequestHeader('Content-type', 'application/json');
    request.addEventListener('load', callback);
    request.send(JSON.stringify(body));
}
export function sendBackendData(username, endpoint, method, acceptFormat, token, body, callback) {
    let request = new XMLHttpRequest();
    request.open(method, API_URL + endpoint + username);
    request.setRequestHeader('Accept', acceptFormat);
    request.setRequestHeader('Authorization', 'Bearer ' + token);
    request.setRequestHeader('Content-type', 'application/json');
    request.addEventListener('load', callback);
    request.send(JSON.stringify(body));
}
export function sendBackendDataStream(username, endpoint, method, token, body, onChunk) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const response = yield fetch(API_URL + endpoint + username, {
            method: method,
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        if (!response.body)
            return;
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let partialChunk = '';
        while (true) {
            const { done, value } = yield reader.read();
            if (done)
                break;
            const chunk = decoder.decode(value, { stream: true });
            const lines = (partialChunk + chunk).split('\n');
            partialChunk = lines.pop() || '';
            for (const line of lines) {
                if (line.startsWith('data: ')) {
                    const data = line.slice(6);
                    if (data === '[DONE]')
                        continue;
                    try {
                        const json = JSON.parse(data);
                        const content = ((_b = (_a = json.choices[0]) === null || _a === void 0 ? void 0 : _a.delta) === null || _b === void 0 ? void 0 : _b.content) || '';
                        if (content) {
                            onChunk(content);
                        }
                    }
                    catch (e) {
                    }
                }
            }
        }
    });
}
